import type { RequestFn } from '../http';
import type { DispatchBoardResponse, DispatchFilters } from '../types';

export function createDispatchApi(request: RequestFn) {
  return {
    async getDispatchBoard(filters: DispatchFilters = {}) {
      const params = new URLSearchParams();
      if (filters.boardId) params.set('boardId', String(filters.boardId));
      if (filters.statusIds && filters.statusIds.length > 0) {
        params.set('statusIds', filters.statusIds.join(','));
      }
      if (filters.includeClosed !== undefined) {
        params.set('includeClosed', String(filters.includeClosed));
      }
      if (filters.search) params.set('search', filters.search);
      if (filters.pageSize) params.set('pageSize', String(filters.pageSize));
      if (filters.page) params.set('page', String(filters.page));

      const query = params.toString() ? `?${params.toString()}` : '';
      return request<DispatchBoardResponse>(`/cw/dispatch-board${query}`);
    },

    async clearDispatchCache() {
      return request<{ success: boolean; message: string }>('/cw/dispatch-board/cache/clear', {
        method: 'POST',
      });
    },
  };
}
